const messages = {
  title: "Vaučeri",
  short_description:
    "Ovdje možete pronaći vašu listu vaučera. Možete ih podijeliti sa vašim klijentom. Vaučeri se koriste jednom.",
  table: {
    headers: {
      voucher: "Kodovi vaučera",
      company: "Kompanija",
      street: "Ulica",
      postcode: "Poštanski broj",
      location: "Lokacija",
      solved_at: "Datum",
      points: "Broj bodova preko koda",
    },
  },
  exchange: {
    title: "Unesite vaš kod da dobijete bodove",
    pointsLabel: "Unesite kod ovdje:",
    result: "Broj bodova:",
  },
};

export default {
  messages,
};
